/**
 * 3cad ERP v0.1 (c) 2018 Dau SRL
 * @license commercial
 */
import Vue from 'vue';
// import Vuex from 'vuex';
import VueRouter from 'vue-router';
import { App } from '@3cad/nextcore';
import { NextApiClient } from '@3cad/nextcore';
import { _ApiClientTest } from '@facades/RenderFarm';
import { COcomm } from '@3cad/nextcore';
import { Auth } from '@3cad/nextcore';
import { BrowserDetector } from "@3cad/nextcore";
import { customImport } from "@/utils";
import { utils } from '@3cad/nextcore';
const { loadJson, toLowerCaseKey } = utils

import {store} from "@store/store"
// main application components
import AppComp from "@custom/startFrame.vue";

if (COcomm.isChildPage()) {
    const iFrameComm = new COcomm();

    Vue.mixin({
        data() {
            return {
                iframeCom: iFrameComm
            }
        }
    });
}

const _hostname = window.location.hostname;
let routes = [
    {
        path: '/rsalogin/:key',
        name: 'rsa',
        component: () => import("@custom/pages/rsaLoginFrame.vue")
    }
];

let printError = errMsg => {
    let errEl = document.getElementsByClassName('loading-error')[0];
    errEl.innerText = 'Error: ' + errMsg;
};

// Define to update config when is updated in App
App.onUpdateConfig = config => {
    store.commit('setPreferences', config);
}

// Load config file asynchronously
loadJson('./config/' + process.dau._CONFIG + '?v=' + (new Date()).getTime())
    .then(json => {
        function toLowerCaseKey(obj) {
            let keys = Object.keys(obj);
            let newobj = {};
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];
                newobj[key.toLowerCase()] = obj[key];
            }
            return newobj;
        }

        // Set backend in NextApiClient
        NextApiClient.backSite = json.backsite;
        _ApiClientTest.basePath = json.config.rfServer.replace(/\/+$/, '');
        App.initTranlsator(json.config.transname);
        let config = json.config;
        let bkList = json.sites;
        let bkFind = bkList.find(r => {
            return r === json.backsite;
        })

        // Add current backend to backend list if missing
        if(!bkFind)
            json.sites.push(json.backsite);
        json.dclass = toLowerCaseKey(json.dclass);


        Vue.mixin({
            computed: {
                lengthUnit() {
                    return json.config.measures.length;
                },
                weightUnit() {
                    return json.config.measures.weight;
                },
                volumeUnit() {
                    return json.config.measures.volume;
                }
            }
        })

        // Load dclasses components
        for (let k in json.dclass) {
            let dClass = json.dclass[k];
            if (dClass.comp)
                Vue.component(dClass.comp, () => customImport('dclasses/' + dClass.comp));
        }

        function loadvue() {
            new Vue({
                store: store,
                router: new VueRouter({routes}),
                el: '#app',
                render: h => h(AppComp),
            })
        }

        App.setConfig(json);
        loadvue()
    })
    .catch(err => {
        console.error(err);
        printError('Missing or wrong configuration file');
    })



// WEBPACK FOOTER //
// ./src/custom/cattelan/chunks/main.cattelan.js